var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdentifyRisk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_31678)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_437_31678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7188 24.2792V25.1562H16.8984V25.9766C16.8984 28.2382 18.7384 30.0781 21 30.0781C23.2616 30.0781 25.1016 28.2382 25.1016 25.9766V25.1562H24.2812V24.2792C25.4075 23.7206 26.3711 22.8854 27.0898 21.8389C27.9357 20.6071 28.3828 19.1635 28.3828 17.6641V14.3828C28.3828 10.3119 25.0709 7 21 7C16.9291 7 13.6172 10.3119 13.6172 14.3828V17.6641C13.6172 19.1635 14.0643 20.6071 14.9102 21.8389C15.6289 22.8854 16.5925 23.7206 17.7188 24.2792ZM21 20.125C20.547 20.125 20.1797 19.7577 20.1797 19.3047C20.1797 18.8517 20.547 18.4844 21 18.4844C21.453 18.4844 21.8203 18.8517 21.8203 19.3047C21.8203 19.7577 21.453 20.125 21 20.125ZM21 10.2812C22.357 10.2812 23.4609 11.3852 23.4609 12.7422C23.4609 13.5121 23.0931 14.2481 22.4769 14.7108C22.0658 15.0196 21.8203 15.5103 21.8203 16.0234C21.8203 16.4765 21.453 16.8438 21 16.8438C20.547 16.8438 20.1797 16.4765 20.1797 16.0234C20.1797 14.997 20.6701 14.0159 21.4917 13.399C21.7005 13.2421 21.8203 13.0027 21.8203 12.7422C21.8203 12.2899 21.4523 11.9219 21 11.9219C20.5477 11.9219 20.1797 12.2899 20.1797 12.7422C20.1797 13.1952 19.8124 13.5625 19.3594 13.5625C18.9063 13.5625 18.5391 13.1952 18.5391 12.7422C18.5391 11.3852 19.643 10.2812 21 10.2812Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7422 25.1939V25.9766C26.7422 29.1428 24.1662 31.7188 21 31.7188C17.8338 31.7188 15.2578 29.1428 15.2578 25.9766V25.1939C10.6653 25.6098 7.05469 29.4807 7.05469 34.1797C7.05469 34.6327 7.42197 35 7.875 35H34.125C34.578 35 34.9453 34.6327 34.9453 34.1797C34.9453 29.4807 31.3347 25.6098 26.7422 25.1939Z",
    fill: "#00994E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_31678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(7 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_437_31678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentifyRisk);
export default __webpack_public_path__ + "static/media/identifyRisk.a457bb0ea53fbe366d6ea91ea6980e5a.svg";
export { ForwardRef as ReactComponent };